import type { SxProps, Theme } from "@mui/material";

export const dataGridSx: SxProps<Theme> = (theme) => ({
  "width": "100%",
  "height": "100%",
  "border": 0,

  "& .MuiDataGrid-columnSeparator": {
    display: "none",
  },

  '& .MuiDataGrid-columnHeaderTitleContainerContent svg[data-testid="ArrowDownwardIcon"]': {
    opacity: 0,
  },

  "&& .MuiDataGrid-columnHeaders, && .MuiDataGrid-columnHeader": {
    backgroundColor: "#DDE1E6",
  },
  "&& .MuiDataGrid-filler": {
    backgroundColor: "#DDE1E6",
  },

  "& .MuiDataGrid-virtualScroller": {
    overflowX: "auto",
  },
  "& .MuiDataGrid-virtualScrollerContent": {
    overflowX: "hidden",
  },
  "& .MuiDataGrid-row:hover": {
    cursor: "pointer",
  },
  "& .MuiDataGrid-columnHeader": {
    fontWeight: theme.typography.fontWeightBold,
    backgroundColor: `${(theme.palette as any).background.menu} !important`,
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    fontWeight: theme.typography.fontWeightBold,
  },
  "& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader": {
    display: "flex",
    alignItems: "center",
  },
  "& .freeze-right": {
    position: "sticky",
    right: 0,
    backgroundColor: theme.palette.background.paper,
    zIndex: 1,
  },
  "& .MuiDataGrid-columnHeader.freeze-right": {
    position: "sticky",
    right: 0,
    backgroundColor: `${(theme.palette as any).background.menu} !important`,
    zIndex: 2,
  },
  "& .MuiDataGrid-row:hover .freeze-right, .MuiDataGrid-row.Mui-selected .freeze-right": {
    borderLeft: `1px solid ${theme.palette.divider}`,
  },
  "& .freeze-first": {
    right: 160,
  },
  "& .MuiDataGrid-columnHeader.freeze-first": {
    right: 160,
  },
  "& .MuiDataGrid-filler": { display: "none" },
  "& .MuiDataGrid-row.row--unseen": {
    fontWeight: 700,
  },
  "& .MuiDataGrid-row.row--unseen .MuiDataGrid-cell": {
    fontWeight: 700,
  },
  "& .MuiDataGrid-row.row--unseen .MuiDataGrid-cell > *": {
    fontWeight: "inherit",
  },
  '& .MuiDataGrid-row.row--unseen .MuiDataGrid-cell:not([data-field="status"]) *': {
    fontWeight: "inherit !important",
  },
});

export const dataGridWrapperSx = {
  "& .MuiDataGrid-scrollbar--horizontal": { position: "static !important" },
};
